import { TUpdateUser, TUser } from "@/models/user.model";
import { sortUsers } from "@/utils/users.utils";
import axios from "@utils/axios-instance";

export const getAllUsers = async (): Promise<TUser[]> => {
  const response = await axios.get("/users");
  return sortUsers(response.data);
};

const inviteUser = async (data: { email: string; roles: number[] }): Promise<TUser> => {
  const response = await axios.post("/users/invite", data);
  return response.data;
};

const updateUser = async (data: TUpdateUser) => {
  const { id, ...payload } = data;
  await axios.patch(`/users/${id}`, payload);
};

const setUserRoles = async (userId: number, roleIds: number[]) => {
  await axios.patch(`/users/${userId}`, { roles: roleIds });
};

const deleteuser = async (userId: number, reassignToUserId?: number) => {
  const params = reassignToUserId ? { reassignToUserId } : {};
  await axios.delete(`/users/${userId}`, { params });
};

export default {
  getAllUsers,
  inviteUser,
  updateUser,
  setUserRoles,
  deleteuser,
};
